import React from "react";
import "./Participants.css";
import participants from "../../data/participants";

const Participants = () => {
  return (
    <section className="pad pad-top flex">
      <h2>Participating Countries</h2>
      <p className="lottolegenda-participants__small-header">
        Vikinglotto is available in:
      </p>
      <ul className="lottolegenda-participants__container">
        {participants.map((i) => (
          <li key={i.id}>
            <div className="lottolegenda-participants__flag" style={{backgroundImage: `url(${i.flag})`}}></div>
            <p className="fw-700 t-21">{i.countryName}</p>
          </li>
        ))}
      </ul>
    </section>
  );
};

export default Participants;
